import { Box, Text } from '@wix/design-system';
import { FunctionComponent } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import Image from 'next/image';
import css from './index.module.scss';

export const GenAnswerLoader: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Box className={css.loadingAnswer}>
      <Box direction='vertical' align='center'>
        <Image
        className={css.loadingImage}
          src="https://static.parastorage.com/services/kb-client-nextjs/dist/public/images/ai/generating-loading.gif"
          alt="loading-generated-answer"
          width="120"
          height="120"
          loading="eager"
        />
        <Text size='small' >
          {t('search-results-page.gen-answer.loading')}
        </Text>
      </Box>
    </Box>
  );
};
